export interface AuthState {
  token: string | null;
  id: string | null;
  expiresAt: Date | null;
  refreshToken: string | null;
  email: string | null;
  firstName: string | null;
  surName: string | null;
  dateFormat: string | null;
  timeFormat: string | null;
  language: string | null;
  timeZone: string | null;
  roles: string[];
  claims: string[];
  permissionGroups: string[];
  userLoggedCustomCompanies: string[];
  loadingMessage: string | undefined;
  isLoading?: boolean;
  error?: string | null;
  companyId?: string | null;
  tenantId?: string | null;
  isTemporary?: boolean;
  bankRelationshipId?: string | null;
  bankRelationshipName?: string | null;
  temporaryAccessExpiration?: Date | null;
  selectedEconomicGroupId: string | null;
  selectedEconomicGroupName: string | null;
}

export interface UserLocalizationSetting {
  dateFormat: string | null;
  timeFormat: string | null;
  language: string | null;
  timeZone: string | null;
}

export const initialAuthState: AuthState = {
  token: null,
  id: null,
  expiresAt: null,
  refreshToken: null,
  email: null,
  firstName: null,
  surName: null,
  dateFormat: null,
  timeFormat: null,
  language: null,
  timeZone: null,
  roles: [],
  claims: [],
  permissionGroups: [],
  userLoggedCustomCompanies: [],
  loadingMessage: undefined,
  isLoading: false,
  error: null,
  companyId: null,
  bankRelationshipId: null,
  bankRelationshipName: null,
  temporaryAccessExpiration: null,
  selectedEconomicGroupId: null,
  selectedEconomicGroupName: null,
};
